export const FETCH_AUDIT_PENDING = 'FETCH_AUDIT_PENDING';
export const FETCH_AUDIT_SUCCESS = 'FETCH_SCHEDULER_SUCCESS';
export const FETCH_AUDIT_ERROR = 'FETCH_SCHEDULER_ERROR';
export const FETCH_USER_ERROR='FETCH_USER_ERROR';
export const FETCH_USER_SUCCESS='FETCH_USER_SUCCESS';
export const UPDATE_TOTAL_PAGES='UPDATE_TOTAL_PAGES';
export const UPDATE_ROWS_PER_PAGE='UPDATE_ROWS_PER_PAGE';